import $ from 'jquery';
import Foundation from './3rd/_zf.js';
import { hdConfig } from './components/config.js';

import './components/global.js';
import './components/lighthouse.js';
import './components/back-to-top.js';
import './components/script-loader.js';
import { initMenu } from './components/menu.js';
import { initSocialShare } from './components/social-share.js';
//import SimpleBar from 'simplebar';
//import ResizeObserver from 'resize-observer-polyfill';
import { Fancybox } from '@fancyapps/ui';
//import select2 from 'select2';

//window.ResizeObserver = ResizeObserver;
//select2();

// Styles
import '../sass/3rd/_index.scss';
//import 'simplebar/dist/simplebar.css';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

// DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    initMenu('nav.nav', '.main-nav');
    initSocialShare('[data-social-share]', { intents: [ 'facebook', 'x', 'print', 'send-email', 'copy-link', 'web-share' ] });
});

Fancybox.bind('.fcy-popup, .fcy-video, .banner-video a', {});
Fancybox.bind('.wp-block-gallery .wp-block-image a, [id^="gallery-"] a', {
    groupAll: true, // Group all items
});
Fancybox.bind('[data-rel^="lightbox-"]', {
    groupAll: true, // Group all items
});
Fancybox.bind("[data-fancybox]", {});
jQuery(function ($) {
  let header = $('#inside-header');
  let headerHeight = header.outerHeight();

  $(window).on('scroll', function () {
    let scrollTop = $(this).scrollTop();
    if (scrollTop > headerHeight + 100) {
      header.addClass('w-sticky');
    } else {
      header.removeClass('w-sticky');
    }
  });
});

jQuery(function ($) {
    /** */
    const wpg__image = $('.wpg__image');
    wpg__image.find('a').on('click', function (e) {
        e.preventDefault();
        $(this).next('.image-popup').trigger('click');
    });

    /** */
    const wpg__thumb = $('.wpg__thumb');
    wpg__thumb.find('a').on('click', function (e) {
        e.preventDefault();
    });
});

// 
jQuery(document).ready(function ($) {
  $('.btn-packaging').on('click', function () {
    jQuery(this).closest('.product-item').find('.col-product-default').hide();
    var productId = $(this).data('product-id');
    var index = $(this).data('index');
    var $product = $('.product-item[data-product-id="' + productId + '"]');
    // Active button
    $product.find('.btn-packaging').removeClass('active');
    $(this).addClass('active');
    // hide gallery
    $product.find('.packaging-gallery').removeClass('active');
    // show gallery
    var $newGallery = $product.find('.packaging-gallery[data-index="' + index + '"]');
    $newGallery.addClass('active');

    $product.find('.product-attributes').removeClass('active');
    var $newAttributes = $product.find('.product-attributes-packaging[data-index="' + index + '"]');
    $newAttributes.addClass('active');

    var imageSwiper = $newGallery.find('.swiper-images')[0]?.swiper;
    var thumbSwiper = $newGallery.find('.swiper-thumbs')[0]?.swiper;
    if (imageSwiper) imageSwiper.update();
    if (thumbSwiper) thumbSwiper.update();
  });

  $('.product-item').each(function () {
        const productID = $(this).data('product-id'); // giả sử bạn có sẵn data-product-id
        $(this).find('.image-popup').attr('data-rel', 'lightbox-' + productID);
    });
    Fancybox.bind('[data-rel^="lightbox-"]', {
        groupAll: false
    });
});